<template>
    <div class="clients2">
    <v-dialog v-model="dialogDelete" max-width="290">
        <v-card>
            <v-card-title class="headline">
                {{$t('msg_delete_client')}}
            </v-card-title>

            <v-card-text>
                {{$t('msg_eliminar_invitacion_2')}}
            </v-card-text>

            <v-card-actions>
                <v-btn
                        color="primary"
                        @click="dialogDelete = false"
                >
                    No
                </v-btn>
                <v-spacer/>
                <v-btn
                        color="primary"
                        :loading="loadingAddClient"
                        @click="deleteClient"
                >
                    {{$t('Si')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogClientes" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Capturar Datos de la nueva sección</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- N° de Cliente -->
            <!-- <v-text-field
              v-model="cliente.code"
              :label="$t('client_number')"
              :rules="[v => !!v || 'El número es requerido']"
              color="primary"
              :error-messages="errores.code"
            ></v-text-field> -->

            <!-- Nombre del Cliente -->
            <v-text-field
              v-model="cliente.name"
              :label="$t('section_name')"
              :rules="[v => !!v || 'El nombre es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Domicilio -->
            <!-- <v-text-field
              v-model="cliente.address"
              :label="$t('client_address')"
              :rules="[v => !!v || 'El domicilio es requerido']"
              color="primary"
            ></v-text-field> -->

            <!-- Tiempo de carga -->
            <!-- <v-text-field
              v-model="cliente.loading_time_minutes"
              :label="$t('loading_time') + ' (min)'"
              type="number"
              min="1"
              :rules="[v => !!v || 'El tiempo es requerido']"
              color="primary"
            ></v-text-field> -->
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialogClientes = false">
            {{ $t('cancelar') }}
          </v-btn>
          <v-btn v-if="update" color="primary" :loading="loadingAddClient" @click="updateClient">
            {{ $t('modificar') }}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            :loading="loadingAddClient"
            @click="createClient"
        >
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <h2 class="subheading grey--text">{{$t('section_name')}}</h2>
        <v-container class="my-5">
            <!--     Dialog Formulario Alta      -->
            <v-layout align-center justify-center fill-height>
                <v-btn
                        class="align-self-end"
                        color="primary"
                        @click="abrirDialogClientes">
                        {{ "+ " + $t('add_section') }}
                </v-btn>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('section')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loadingClients"
                            :items="clients"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="$t('no_records_clients')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        class="mr-2"
                                        @click="llenarDialogClientes(props.item), update = true, id_update = props.item.id"
                                    >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogDelete = true, id_update = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.name }}</td>
                            <!-- <td>{{ props.item.loading_time_minutes }}</td> -->
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('clients')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "clients2",
        data: () => ({
            clients: [],
            update:false,
            id_update: 0,
            errores: [],
            dialogClientes: false,
            search: '',
            headers: [],
            loadingClients: false,
            loading: false,
            valid: true,
            cliente: {
                name: ''
            },
            loadingAddClient: false,
            id_empresa: '',
            dialogDelete: false,
            isLoading: false
        }),
        beforeUpdate (){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'left',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('section_name'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                }
            ]
        },
        created: function () {
            this.get_extra_data()
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        methods: {
            get_extra_data (){
                this.loadingClients = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getClients()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getClients () {
                this.loadingClients = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/sections/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        idEmpresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.clients = response.data
                        this.loadingClients = false
                    })
                    .catch(error => {
                        this.loadingClients = false
                        console.log(error)
                    })
            },
            abrirDialogClientes() {
                this.update = false
                this.id_update = 0
                this.errores = []
                this.dialogClientes = true
                this.$refs.form.resetValidation()
                this.limpiarFormulario()
            },
            llenarDialogClientes(item) {
                this.errores = []
                this.dialogClientes = true
                this.cliente = {
                    name: item.name
                }
            },
            createClient() {
                if (this.$refs.form.validate()) {
                    this.errores = []
                    if (this.$refs.form.validate()) {
                        this.loadingAddClient = true
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/Parking/sections/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                idEmpresa: this.id_empresa,
                                name: this.cliente.name,
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loadingAddClient = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('client_data_added'))
                                this.getClients()
                                this.limpiarFormulario()
                                this.dialogClientes = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loadingAddClient = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }
            },
            updateClient() {
                if (this.$refs.form.validate()) {
                    this.errores = []
                    if (this.$refs.form.validate()) {
                        this.loadingAddClient = true
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/Parking/sections/' + this.id_update + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                idEmpresa: this.id_empresa,
                                name: this.cliente.name,
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loadingAddClient = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('client_data_updated'))
                                this.getClients()
                                this.limpiarFormulario()
                                this.dialogClientes = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loadingAddClient = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }
            },
            deleteClient () {
                this.errores = []
                this.loadingAddClient = true
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/Parking/sections/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(ok => {
                        this.loadingAddClient = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('client_data_deleted'))
                        this.getClients()
                        this.dialogDelete = false
                        this.limpiarFormulario()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loadingAddClient = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            limpiarFormulario() {
                this.cliente = {
                    name: '',
                }
                this.valid = false
            },
            clear: function () {
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            },
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            }
        }
    }
</script>
